import { useState } from 'react';

const FloatingCTAButton = () => {
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    telefono: '',
    empresa: '',
    tipoLogo: '',
    estilo: '',
    colores: '',
    descripcion: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [submitError, setSubmitError] = useState('');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitError('');

    try {
      // Validar que todos los campos requeridos estén llenos
      if (!formData.nombre || !formData.email || !formData.telefono || !formData.tipoLogo) {
        setSubmitError('Por favor completa todos los campos requeridos');
        setIsSubmitting(false);
        return;
      }

      // Validar email
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(formData.email)) {
        setSubmitError('Por favor ingresa un correo electrónico válido');
        setIsSubmitting(false);
        return;
      }

      // Validar descripción (máximo 500 caracteres)
      if (formData.descripcion.length > 500) {
        setSubmitError('La descripción no puede exceder 500 caracteres');
        setIsSubmitting(false);
        return;
      }

      // Preparar datos para envío con application/x-www-form-urlencoded
      const formBody = new URLSearchParams();
      formBody.append('nombre', formData.nombre);
      formBody.append('email', formData.email);
      formBody.append('telefono', formData.telefono);
      formBody.append('empresa', formData.empresa || 'No especificado');
      formBody.append('tipoLogo', formData.tipoLogo);
      formBody.append('estilo', formData.estilo || 'No especificado');
      formBody.append('colores', formData.colores || 'No especificado');
      formBody.append('descripcion', formData.descripcion || 'No especificado');
      formBody.append('correoDestino', 'logoideas05@gmail.com');
      formBody.append('whatsappDestino', '7131055034');

      const response = await fetch('https://readdy.ai/api/form/d5jiojh845a7l1lrhelg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitSuccess(true);
        setFormData({
          nombre: '',
          email: '',
          telefono: '',
          empresa: '',
          tipoLogo: '',
          estilo: '',
          colores: '',
          descripcion: ''
        });
        
        // Cerrar modal después de 3 segundos
        setTimeout(() => {
          setShowModal(false);
          setSubmitSuccess(false);
        }, 3000);
      } else {
        setSubmitError('Hubo un error al enviar el formulario. Por favor intenta de nuevo.');
      }
    } catch (error) {
      setSubmitError('Error de conexión. Por favor verifica tu internet e intenta de nuevo.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      {/* Botón Flotante Mejorado */}
      <button
        onClick={() => setShowModal(true)}
        className="fixed bottom-8 right-8 z-50 group whitespace-nowrap cursor-pointer"
        aria-label="Obtener logo profesional"
      >
        <div className="relative">
          {/* Efecto de resplandor */}
          <div className="absolute inset-0 rounded-2xl bg-gradient-to-r from-emerald-400 via-teal-500 to-cyan-500 blur-xl opacity-60 group-hover:opacity-90 transition-opacity duration-300"></div>
          
          {/* Botón principal */}
          <div className="relative bg-gradient-to-r from-emerald-500 to-teal-600 hover:from-emerald-400 hover:to-teal-500 text-white px-8 py-5 rounded-2xl shadow-2xl transform transition-all duration-300 group-hover:scale-105 flex items-center gap-4 border-2 border-white/20">
            <div className="w-14 h-14 flex items-center justify-center rounded-xl bg-white/20 backdrop-blur-sm">
              <i className="ri-palette-line text-3xl"></i>
            </div>
            <div className="text-left">
              <div className="text-sm font-semibold opacity-95 mb-1">Logo Profesional</div>
              <div className="text-2xl font-bold tracking-tight">$299.00</div>
              <div className="text-xs opacity-90 mt-0.5">¡Oferta Especial!</div>
            </div>
          </div>
          
          {/* Badge de oferta */}
          <div className="absolute -top-3 -right-3 bg-gradient-to-r from-orange-500 to-red-500 text-white text-xs font-bold px-3 py-1.5 rounded-full shadow-lg animate-pulse border-2 border-white">
            HOY
          </div>
        </div>
      </button>

      {/* Modal del Formulario Mejorado */}
      {showModal && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-md">
          <div className="relative w-full max-w-3xl max-h-[90vh] overflow-y-auto bg-white rounded-3xl shadow-2xl">
            
            {/* Header del Modal */}
            <div className="sticky top-0 z-10 bg-gradient-to-r from-emerald-500 via-teal-500 to-cyan-500 px-8 py-8 rounded-t-3xl">
              <button
                onClick={() => setShowModal(false)}
                className="absolute top-6 right-6 text-white/80 hover:text-white transition-colors cursor-pointer w-10 h-10 flex items-center justify-center rounded-full hover:bg-white/20"
                aria-label="Cerrar"
              >
                <i className="ri-close-line text-3xl"></i>
              </button>

              <div className="text-center text-white">
                <div className="inline-flex items-center justify-center w-20 h-20 bg-white/20 backdrop-blur-sm rounded-2xl mb-4 border-2 border-white/30">
                  <i className="ri-palette-line text-4xl"></i>
                </div>
                <h2 className="text-4xl font-bold mb-2">
                  Logo Profesional
                </h2>
                <div className="text-3xl font-bold mb-2">
                  $299.00 pesos
                </div>
                <p className="text-white/90 text-lg">
                  Completa el formulario y nos pondremos en contacto contigo
                </p>
              </div>
            </div>

            {/* Formulario */}
            <div className="px-8 py-8">
              <form 
                id="logo-form"
                data-readdy-form
                onSubmit={handleSubmit} 
                className="space-y-6"
              >
                {/* Grid de 2 columnas para campos principales */}
                <div className="grid md:grid-cols-2 gap-6">
                  {/* Nombre completo */}
                  <div>
                    <label htmlFor="nombre" className="block text-sm font-semibold text-gray-700 mb-2">
                      Nombre completo <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      id="nombre"
                      name="nombre"
                      value={formData.nombre}
                      onChange={handleInputChange}
                      required
                      className="w-full px-4 py-3 bg-gray-50 border-2 border-gray-200 rounded-xl text-gray-800 placeholder-gray-400 focus:outline-none focus:border-emerald-500 focus:bg-white transition-all"
                      placeholder="Tu nombre completo"
                    />
                  </div>

                  {/* Email */}
                  <div>
                    <label htmlFor="email" className="block text-sm font-semibold text-gray-700 mb-2">
                      Correo electrónico <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      required
                      className="w-full px-4 py-3 bg-gray-50 border-2 border-gray-200 rounded-xl text-gray-800 placeholder-gray-400 focus:outline-none focus:border-emerald-500 focus:bg-white transition-all"
                      placeholder="tu@email.com"
                    />
                  </div>

                  {/* Teléfono/WhatsApp */}
                  <div>
                    <label htmlFor="telefono" className="block text-sm font-semibold text-gray-700 mb-2">
                      Teléfono/WhatsApp <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="tel"
                      id="telefono"
                      name="telefono"
                      value={formData.telefono}
                      onChange={handleInputChange}
                      required
                      className="w-full px-4 py-3 bg-gray-50 border-2 border-gray-200 rounded-xl text-gray-800 placeholder-gray-400 focus:outline-none focus:border-emerald-500 focus:bg-white transition-all"
                      placeholder="10 dígitos"
                    />
                  </div>

                  {/* Nombre de la empresa */}
                  <div>
                    <label htmlFor="empresa" className="block text-sm font-semibold text-gray-700 mb-2">
                      Nombre de la empresa
                    </label>
                    <input
                      type="text"
                      id="empresa"
                      name="empresa"
                      value={formData.empresa}
                      onChange={handleInputChange}
                      className="w-full px-4 py-3 bg-gray-50 border-2 border-gray-200 rounded-xl text-gray-800 placeholder-gray-400 focus:outline-none focus:border-emerald-500 focus:bg-white transition-all"
                      placeholder="Nombre de tu empresa"
                    />
                  </div>
                </div>

                {/* Tipo de logo */}
                <div>
                  <label htmlFor="tipoLogo" className="block text-sm font-semibold text-gray-700 mb-2">
                    Tipo de logo <span className="text-red-500">*</span>
                  </label>
                  <select
                    id="tipoLogo"
                    name="tipoLogo"
                    value={formData.tipoLogo}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 bg-gray-50 border-2 border-gray-200 rounded-xl text-gray-800 focus:outline-none focus:border-emerald-500 focus:bg-white transition-all cursor-pointer"
                  >
                    <option value="">Selecciona un tipo</option>
                    <option value="Logotipo">Logotipo (solo texto)</option>
                    <option value="Isotipo">Isotipo (solo símbolo)</option>
                    <option value="Imagotipo">Imagotipo (texto + símbolo separados)</option>
                    <option value="Isologo">Isologo (texto + símbolo unidos)</option>
                  </select>
                </div>

                {/* Grid de 2 columnas para preferencias */}
                <div className="grid md:grid-cols-2 gap-6">
                  {/* Estilo preferido */}
                  <div>
                    <label htmlFor="estilo" className="block text-sm font-semibold text-gray-700 mb-2">
                      Estilo preferido
                    </label>
                    <select
                      id="estilo"
                      name="estilo"
                      value={formData.estilo}
                      onChange={handleInputChange}
                      className="w-full px-4 py-3 bg-gray-50 border-2 border-gray-200 rounded-xl text-gray-800 focus:outline-none focus:border-emerald-500 focus:bg-white transition-all cursor-pointer"
                    >
                      <option value="">Selecciona un estilo</option>
                      <option value="Minimalista">Minimalista</option>
                      <option value="Moderno">Moderno</option>
                      <option value="Elegante">Elegante</option>
                      <option value="Creativo">Creativo</option>
                      <option value="Corporativo">Corporativo</option>
                      <option value="Vintage">Vintage</option>
                    </select>
                  </div>

                  {/* Colores preferidos */}
                  <div>
                    <label htmlFor="colores" className="block text-sm font-semibold text-gray-700 mb-2">
                      Colores preferidos
                    </label>
                    <input
                      type="text"
                      id="colores"
                      name="colores"
                      value={formData.colores}
                      onChange={handleInputChange}
                      className="w-full px-4 py-3 bg-gray-50 border-2 border-gray-200 rounded-xl text-gray-800 placeholder-gray-400 focus:outline-none focus:border-emerald-500 focus:bg-white transition-all"
                      placeholder="Ej: Azul, dorado, negro"
                    />
                  </div>
                </div>

                {/* Descripción del proyecto */}
                <div>
                  <label htmlFor="descripcion" className="block text-sm font-semibold text-gray-700 mb-2">
                    Descripción del proyecto
                  </label>
                  <textarea
                    id="descripcion"
                    name="descripcion"
                    value={formData.descripcion}
                    onChange={handleInputChange}
                    maxLength={500}
                    rows={4}
                    className="w-full px-4 py-3 bg-gray-50 border-2 border-gray-200 rounded-xl text-gray-800 placeholder-gray-400 focus:outline-none focus:border-emerald-500 focus:bg-white transition-all resize-none"
                    placeholder="Cuéntanos sobre tu proyecto, ideas, inspiración..."
                  ></textarea>
                  <div className="text-right text-xs text-gray-500 mt-1">
                    {formData.descripcion.length}/500 caracteres
                  </div>
                </div>

                {/* Mensaje de error */}
                {submitError && (
                  <div className="bg-red-50 border-2 border-red-200 rounded-xl p-4 text-red-700 text-sm flex items-start gap-3">
                    <i className="ri-error-warning-line text-xl flex-shrink-0 mt-0.5"></i>
                    <span>{submitError}</span>
                  </div>
                )}

                {/* Mensaje de éxito */}
                {submitSuccess && (
                  <div className="bg-emerald-50 border-2 border-emerald-200 rounded-xl p-4 text-emerald-700 text-sm flex items-start gap-3">
                    <i className="ri-checkbox-circle-line text-xl flex-shrink-0 mt-0.5"></i>
                    <span>¡Formulario enviado exitosamente! Nos pondremos en contacto contigo pronto.</span>
                  </div>
                )}

                {/* Botón enviar */}
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full bg-gradient-to-r from-emerald-500 to-teal-600 hover:from-emerald-400 hover:to-teal-500 text-white font-bold py-4 rounded-xl transition-all duration-300 transform hover:scale-[1.02] disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none whitespace-nowrap cursor-pointer shadow-lg hover:shadow-xl"
                >
                  {isSubmitting ? (
                    <span className="flex items-center justify-center gap-3">
                      <i className="ri-loader-4-line animate-spin text-xl"></i>
                      Enviando...
                    </span>
                  ) : (
                    <span className="flex items-center justify-center gap-3">
                      <i className="ri-send-plane-fill text-xl"></i>
                      Solicitar Logo Profesional
                    </span>
                  )}
                </button>

                <p className="text-center text-sm text-gray-500">
                  Al enviar este formulario, recibirás una respuesta por correo y WhatsApp
                </p>
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default FloatingCTAButton;
